// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { expertCouncilsManifest } from './expert-councils';
import { expertNetworkManifest } from './expert-network';

/** Група модулів «Експерти» (Experts): 2 модулів. */
export const expertsGroup: IModuleGroupManifest = {
  key: 'experts',
  category: 'Experts',
  name: { en: 'Experts', uk: 'Експерти' },
  sort: 4,
  modules: [expertCouncilsManifest, expertNetworkManifest],
};
